var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiForkspoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--forkspoon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--forkspoon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.436 12.564h.795v-4.41c.301-.076.552-.228.751-.456.2-.228.3-.505.3-.832V4.398c0-.08-.03-.15-.087-.207a.283.283 0 00-.208-.088c-.08 0-.15.03-.208.088a.284.284 0 00-.087.207v1.898h-.564V4.397c0-.08-.03-.15-.087-.207a.283.283 0 00-.208-.088c-.08 0-.15.03-.208.088a.284.284 0 00-.087.207v1.898h-.564V4.397c0-.08-.029-.15-.087-.207a.283.283 0 00-.208-.088c-.08 0-.15.03-.207.088a.284.284 0 00-.088.207v2.47c0 .326.1.603.3.83.2.229.45.38.752.457v4.41zm4 0h.794V8.369c.363-.156.648-.423.855-.799.208-.376.312-.82.312-1.334 0-.612-.149-1.12-.446-1.526-.297-.405-.67-.608-1.118-.608-.448 0-.82.203-1.118.608-.297.405-.446.914-.446 1.526 0 .513.104.958.312 1.334.207.376.492.643.855.799v4.195zm-6.564 1.77c-.337 0-.622-.117-.856-.35a1.163 1.163 0 01-.35-.856V2.872c0-.337.117-.622.35-.855.234-.234.519-.35.856-.35h10.256c.337 0 .622.116.855.35.233.233.35.518.35.855v10.256c0 .337-.117.622-.35.855-.233.233-.518.35-.855.35H2.872zm0-1h10.256a.196.196 0 00.14-.065.196.196 0 00.065-.141V2.872a.196.196 0 00-.064-.141.196.196 0 00-.141-.064H2.872a.196.196 0 00-.141.064.196.196 0 00-.065.14v10.257c0 .051.022.098.065.141.042.043.09.064.14.064z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--forkspoon-22bde6ebc6606419a0eaa60219798949.svg";
export { SvgIconUiForkspoon as Component };